// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1l-q6","signatureBlock":"Footer_signatureBlock__1jEEI","signature":"Footer_signature__1wVEw"};